export const DEFAULT_KEYWORD_FIELDS = ['TA_ALL', 'TAC_ALL', 'TTL_ALL', 'ABST_ALL'];
export const DEFAULT_ASSIGNEE_FIELDS = ['ALL_AN', 'ANCS', 'ANC', 'ANS'];
export const DEFAULT_CLASSIFICATION_NUMBER_FIELDS = ['IPC', 'CPC', 'LOC', 'UPC'];
export const DEFAULT_OTHER_FIELDS = ['IN', 'PBD', 'APD', 'PN'];
export const SECTION_TYPE_HISTORY = 'HISTORY';
export const SECTION_TYPE_FIELD = 'FIELD';
export const SECTION_TYPE_KEYWORDS = 'KEYWORDS';
export const SECTION_TYPE_SAMPLE = 'SAMPLE';
